<div fxFlex="100%" class="tw-justify-stretch tw-items-stretch">

    <section fxFlex class="p-fluid tw-relative">
        <input id="search-item-input" type="text" pInputText #globalSearchFilter (focus)="this.showResult = true"
            placeholder="{{this.searchConfig.inputBoxPlaceHolder}}" />
        <div class="tw-absolute tw-top-0 tw-right-1 tw-cursor-pointer tw-flex tw-h-full tw-items-center tw-place-content-start"
            (click)="this.showMemberHistory($event)">
            <div class="flex items-center gap-1 text-sm text-gray-600">
                <kbd
                    class="tw-rounded tw-bg-gray-100 tw-px-2 tw-py-1 tw-font-mono tw-text-xs tw-text-gray-600 tw-shadow-sm tw-border tw-border-gray-300">
                    Ctrl
                </kbd>
                +
                <kbd
                    class="tw-rounded tw-bg-gray-100 tw-px-2 tw-py-1 tw-font-mono tw-text-xs tw-text-gray-600 tw-shadow-sm tw-border tw-border-gray-300">
                    H
                </kbd>
            </div>
        </div>
    </section>


    <ul class="animated fadeInDown tw-m-0 tw-p-0" style="display: none; z-index: 2;"
        [ngClass]="{'search-result-wrapper show': this.showResult}">

        <section class="filter-message-wrapper">
            <p-messages *ngIf="this.memberSearchService.gridFilters?.length > 0" [severity]="'warn'"
                class="custom-messages small-body-padding">
                <ng-template pTemplate>
                    <em class="fal fa-filter"> </em>
                    <section fxLayout="column">
                        <div class="tw-ml-2" style="padding: 0">
                            <strong>Please note: </strong>
                            {{this.memberSearchService.gridFilters?.length}} filter(s) are being applied. Please use
                            'Full Search' to manage the filters

                        </div>
                    </section>
                </ng-template>
            </p-messages>
        </section>


        <p-toolbar
            *ngIf="!this.searchConfig || !this.searchConfig.hideFullSearchButton || this.searchConfig.showErrorMessage">
            <div fxLayoutAlign="space-between center">
                <div class="ui-toolbar-group-left">
                    <button *ngIf="!this.searchConfig.hideFullSearchButton" pButton pRipple type="button"
                        label="Full Search" icon="fal fa-search" (click)="this.showResult = false"
                        routerLink="/search"></button>
                </div>

                <div class="ui-toolbar-group-right" fxAlign="center"
                    *ngIf="this.searchConfig.showErrorMessage && errorMessage">
                    <span style="color: red; text-decoration: underline;">Criteria Error</span>
                </div>
            </div>
        </p-toolbar>

        <li #searchDialog class="search-result-wrapper result" role="menuitem"
            [hidden]="!memberSearchResult && !searchResultBlocked">

            <section #searchDialogContent class="ui-fluid section-wrapper" fxLayout="column" fxLayoutAlign="start start"
                fxFlex="calc(50%-5px)" fxLayoutGap="20px">
                <section class="result-section" fxLayout="column" fxFlex="100%" fxFlexAlign="stretch">
                    <section class="header-container">
                        <p-header fxFlex fxLayout="row wrap" fxLayoutAlign="space-between center">
                            <strong class="title">Members</strong>
                        </p-header>
                    </section>
                    <p-blockUI *ngIf="this.viewInitialized" [blocked]="this.searchResultBlocked"
                        [target]="this.memberResult">
                        <em class="fal fa-hourglass fa-spin fa-3x app-spinner"></em>
                        <!-- <section class="tw-flex" fxFlex="100%" fxLayoutAlign="center center" fxFlexAlign="stretch"
                            style="height:100%;">
                            <em class="no-flex fal fa-hourglass app-spinner fa-spin fa-3x"></em>
                        </section> -->
                    </p-blockUI>

                    <app-blockable #memberResult class="content" fxFlex="100%" fxLayout="column"
                        fxLayoutAlign="stretch stretch">
                        <section class="tw-overflow-y-auto" fxLayout="row wrap" fxFlex="100%"
                            fxLayoutAlign="start start"
                            [style.height]="this.searchConfig.searchResultsDisplayWindowHeight">

                            <div class="scroll-container" fxFlex="100%" fxFlexFill style="position: relative">
                                <div fxLayout="column" fxFlexFill fxLayoutGap="10px">
                                    <ng-container *ngFor="let member of memberSearchResult">
                                        <section class="result-item" fxFlex="0 1 auto">

                                            <ng-container
                                                *ngTemplateOutlet="(itemTemplate || defaultItemTemplate); context: {$implicit: member}">
                                            </ng-container>

                                        </section>
                                    </ng-container>
                                </div>
                            </div>

                        </section>
                    </app-blockable>
                </section>
            </section>
        </li>

    </ul>

</div>




<ng-template #defaultItemTemplate let-member>
    <ng-container [ngSwitch]="true">
        <section fxFlex="100%" fxLayoutGap="15px">
            <span class="fal fa-user" fxFlex="20px" fxLayout="row" style="color:#757575;"></span>
            <span fxFlex="1 1 100%">
                {{
                member.item.FirstName + ' ' +
                member.item.LastName
                }}
            </span>
        </section>
        <span fxFlex="150px">{{member.item.TenantId}}</span>

        <section class="options" fxFlex="62px" fxLayoutAlign="center center"
            *ngSwitchCase="member.item.SourceType === 'STAGED'">

            <app-smart-actions [key]="member.item.Id" [context]="member.smartActions" [executeActions]="true">
            </app-smart-actions>

        </section>

        <section class="options" fxFlex="62px" fxLayoutAlign="center center" *ngSwitchDefault>

            <app-smart-actions [key]="member.item.Id" [context]="member.smartActions" [executeActions]="true">
            </app-smart-actions>

        </section>
    </ng-container>
</ng-template>
